// extracted by mini-css-extract-plugin
export default {"root":"_1g85A","button":"lInc0"};